var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteMtnBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a48a104c-1900-4475-93fe-29c6ac30e881",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 196.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0,65.34s43.27-.71,153.35-30.11c.41-.11.82-.24,1.23-.38,6.55-2.24,68-22.58,121.38-14.86l35.36,6.4S340.17,32,358.7,35.07s66.84,12.66,95.22,22.51,63.32,16.89,86.54,18.3,73.18,1.64,73.18,1.64a413.87,413.87,0,0,0,52.77-6.1c30.72-5.39,51.92-10,51.92-10s18-3.65,34-14.3,24.39-10.48,24.39-10.48l48-1.7s151.24-2.6,206.38-19.51l22.77-7.24s22.13-7.32,41-8,66.57.55,93.64,8.23c24.89,7.06,61.67,14.59,67.45,15.76.53.1,1.06.19,1.6.27a435.1,435.1,0,0,0,44.72,3.36c25.06.55,74.44,3.81,101.69,11s47.74,13,73,9.52,32.19-4.94,32.19-4.94,58.71-10.6,74.08-11.34,45.91-3.47,70.42-4.39,63.28,4,91.27,13.9,52.85,17.2,87.42,18.3,64.57,2.37,64.57,2.37,18,.55,23.15,2.56V196.63H0Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMtnBottom);
export default __webpack_public_path__ + "static/media/white-mtn-bottom.186b524aafe496084ce2d7b502151fd3.svg";
export { ForwardRef as ReactComponent };